import keyMirror from 'keymirror';

export const lessonRequestModalActionTypes = keyMirror({
	TOGGLE_LESSON_REQUEST_MODAL: null,
	GET_BOOKS_FOR_LESSONS: null,
	GET_BOOKS_FOR_LESSONS_SUCCESS: null,
	GET_BOOKS_FOR_LESSONS_ERROR: null,
	GET_SUBJECTS: null,
	GET_SUBJECTS_SUCCESS: null,
	GET_SUBJECTS_ERROR: null,
	ADD_LESSON_REQUEST: null,
	ADD_LESSON_REQUEST_SUCCESS: null,
	ADD_LESSON_REQUEST_ERROR: null,
	GET_LESSON_BY_CHAPTER: null,
	GET_LESSON_BY_CHAPTER_SUCCESS: null,
	GET_LESSON_BY_CHAPTER_ERROR: null,
	GET_AVAILABLE_SLOTS: null,
	GET_AVAILABLE_SLOTS_SUCCESS: null,
	GET_AVAILABLE_SLOTS_ERROR: null,
	CLEAR_LESSON_REQUEST_MODAL_STATE: null,
});
